import React from 'react';
import WrappedBase from './WrappedBase';

import CommitmentDetails from '../containers/CommitmentDetailsModal';

export default class CommitmentDetailsWrapped extends React.Component {
  render() {
    return (
      <WrappedBase>
        <CommitmentDetails {...this.props} />
      </WrappedBase>
    );
  }
}
